module.exports = __webpack_public_path__ + "img/Medicine.a081dd39.webp";